import { Component, OnInit,Input } from '@angular/core';
import * as Chart from 'chart.js'

@Component({
  selector: 'app-sellers-revenue',
  templateUrl: './sellers-revenue.component.html',
  styleUrls: ['./sellers-revenue.component.css']
})
export class SellersRevenueComponent implements OnInit {

  constructor() { }

  @Input() graphData;

  ngOnInit(){
  }

  title = 'angular8chartjs';
  canvas: any;
  ctx: any;

  ngAfterViewInit() {
    this.canvas = document.getElementById("seller-revenue-chart");
    this.ctx = this.canvas.getContext("2d");
    this.graphData.seller_revenue_graph =  this.graphData.sellers_graph;
    var myLineChart = new Chart(this.ctx, {
      type: 'line',
      data: {
				labels: this.graphData.labels,
				datasets: this.graphData.seller_revenue_graph
      },
      options: {
        xAxes: [{
          type: 'time',
          time: {
            unit: 'day'
          }
        }],
        responsive: false,
        display : true,
        maintainAspectRatio: true,
        lineTension : 100,
        legend: {
          display: true,
          position: "bottom"
        },
        layout: {
          padding: {
             bottom: 0
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
              label: function (tooltipItem, data) {
                  const tooltip = data.datasets[tooltipItem.datasetIndex];
                  const value = tooltip.data[tooltipItem.index];
                  return value.y === 0 ? null : tooltip.label + ': ' + value.y;
              }
          }
        }
      },

  });
  }

}
